export default __webpack_public_path__ + "static/media/O-099.1d173684.png";